import React from "react";
import { Box, Typography } from "@mui/material";
import { convertPenniesToCurrency } from "@tlc/ls2pac/components/AccountMenu";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";

export interface FineLineItemProps {
  fine: HostSystemItemView;
}

export const FineLineItem: React.FC<FineLineItemProps> = ({ fine }) => {
  const fineId = fine.chargeNumber;
  const title = fine.resource?.shortTitle ?? fine.title ?? null;
  const author = fine.resource?.shortAuthor ?? fine.author ?? null;
  const feeComment = fine.feeComment ?? null;
  const fineAmount = convertPenniesToCurrency(fine.fee ?? 0);
  const titleStr = title && author ? `${title} by ${author}` : title ?? null;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "auto 1fr auto",
        columnGap: 2,
        alignItems: "start",
        mb: 1,
      }}
    >
      <Box sx={{ minWidth: 6 }}>
        <Typography lineHeight={1}>{fineId}</Typography>
      </Box>

      <Box>
        {title && (
          <Typography sx={{ wordBreak: "break-word" }} lineHeight={1}>
            {titleStr.substring(0, 100)}
          </Typography>
        )}
        {feeComment && (
          <Typography
            sx={{ wordBreak: "break-word", mt: title ? 0.5 : 0 }}
            lineHeight={1}
          >
            {feeComment}
          </Typography>
        )}
      </Box>

      <Box>
        <Typography
          sx={{ wordBreak: "break-word" }}
          lineHeight={1}
          textAlign="right"
        >
          {fineAmount}
        </Typography>
      </Box>
    </Box>
  );
};
